var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket"},[_c('div',{on:{"click":_vm.toggleDropdown}},[(_vm.count)?_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"icon-shopping-cart"})]),_vm._v(" "),(_vm.items.length && _vm.show)?_c('header-basket-dropdown'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }